import { render, staticRenderFns } from "./vehicle-owner-info-detail-modal.vue?vue&type=template&id=1cb2367a"
import script from "./vehicle-owner-info-detail-modal.vue?vue&type=script&lang=js"
export * from "./vehicle-owner-info-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports